<script setup lang="ts">
  defineProps<{
    isCompact: boolean;
  }>();

  const emit = defineEmits<{ click: [] }>();

  function onBannerClick() {
    navigateTo({ name: ERouteName.BONUSES });
    emit('click');
  }
</script>

<template>
  <div
    class="mb-4 bonus-radial-gradient flex w-full p-2.5 items-center gap-2.5 rounded-[10px] border border-[#0080FF] cursor-pointer hover:brightness-105"
    :class="{ 'justify-center': isCompact }"
    @click="onBannerClick"
  >
    <NuxtImg
      src="/images/pm-tournaments/bonus-medal-art.webp"
      class="relative aspect-square w-12"
      densities="x1 x2"
      preload
      sizes="48px"
    />
    <h4 v-if="!isCompact" class="text-white font-inter text-base not-italic font-semibold leading-[150%]">Bonuses</h4>
  </div>
</template>
